module.exports = __webpack_public_path__ + "img/hero.fed5d426.svg";